import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

const dsn = 'https://0c5ea3eb979440e698963011b4d8c610@o173594.ingest.sentry.io/6331074';
if (dsn) {
	Sentry.init({
		dsn,
		environment: process.env.REACT_SENTRY_ENV || 'development',
	});
}

hydrate();
